<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("TITLES.show_mosque") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #233076">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form>
        <div class="row">
          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.mosque_name_ar')"
            v-model.trim="data.name_ar"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.mosque_name_en')"
            v-model.trim="data.name_en"
            disabled
          />
          <!-- End:: Name Input -->

          <!-- Start:: City Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.city')"
            v-model="data.city_name"
            disabled
          />
          <!-- End:: City Input -->

          <!-- Start:: Address Title Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.address_title')"
            v-model.trim="data.address_title"
            disabled
          />
          <!-- End:: Address Title Input -->

          <!-- Start:: Address Input -->
          <base-input
            col="12"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.address')"
            v-model.trim="data.address"
            disabled
          />
          <!-- End:: Address Input -->

          <!-- Start:: Location Inputs -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.latitude')"
            v-model.trim="data.lat"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.longitude')"
            v-model.trim="data.lng"
            disabled
          />
          <!-- End:: Location Inputs -->

          <!-- Start:: Map Component -->
          <div class="col-12 my-3">
            <MapComponent
              :lat="data.lat ? parseFloat(data.lat) : 24.7136"
              :lng="data.lng ? parseFloat(data.lng) : 46.6753"
            />
          </div>
          <!-- End:: Map Component -->

          <!-- Start:: Created Date Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.created_at')"
            v-model.trim="data.created_at"
            disabled
          />
          <!-- End:: Created Date Input -->

          <!-- Start:: Deactivate Switch Input -->
          <div class="input_wrapper switch_wrapper my-5">
            <v-switch
              color="green"
              :label="
                data.is_active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.is_active"
              hide-details
              disabled
            ></v-switch>
          </div>
          <!-- End:: Deactivate Switch Input -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import MapComponent from "@/components/general/MapComponent";

export default {
  name: "ShowMosque",
  components: {
    MapComponent,
  },
  data() {
    return {
      data: {
        name_ar: "",
        name_en: "",
        city_name: "",
        address: "",
        address_title: "",
        lat: null,
        lng: null,
        is_active: null,
        created_at: "",
      },
    };
  },
  methods: {
    // Start:: Get Mosque Data
    async getMosqueData() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `mosques/${this.$route.params.id}`,
        });
        const mosqueData = res.data.data.mosque;

        this.data.name_ar = mosqueData?.name_ar;
        this.data.name_en = mosqueData?.name_en;
        this.data.city_name =
          mosqueData?.city?.name || mosqueData?.address_title;
        this.data.address = mosqueData?.address;
        this.data.address_title = mosqueData?.address_title;
        this.data.lat = mosqueData?.lat;
        this.data.lng = mosqueData?.lng;
        this.data.is_active = mosqueData?.is_active;
        this.data.created_at = mosqueData?.created_at;
      } catch (error) {
        console.log(error?.response?.data?.message);
      }
    },
    // End:: Get Mosque Data
  },

  created() {
    this.getMosqueData();
  },
};
</script>
